export default __webpack_public_path__ + "static/media/before@2x.9d4f5b8b.png";